import { getFunctions, httpsCallable } from 'firebase/functions'
import { Action } from '../actionTypes'


export const getImages: any = (payload: any) => (dispatch: any) => {
  return new Promise(async (resolve, reject) => {
    const functions = getFunctions()
    const getPhotos = httpsCallable(functions, 'searchPhotos')
    dispatch({
        type: Action.GET_IMAGES_INIT,
      })

      if (payload?.length && payload?.length < 4) {
        payload = payload + '    ';
      }

    getPhotos({'query': payload})

    .then((photos:any) => {
        if (photos?.data && photos?.data?.photos?.length > 0) {
            dispatch({
            type: Action.GET_IMAGES_SUCCESS,
            payload: photos?.data?.photos,
            })
            resolve(photos?.data?.photos)
        } else {
            dispatch({
                type: Action.GET_IMAGES_SUCCESS,
                payload: photos?.data?.photos,
                })
                resolve([])
            }
        })
        .catch((error) => {
            dispatch({
            type: Action.GET_IMAGES_FAIL,
            payload: error,
            })
            reject(error)
        })
    })
}

export const getVideos: any = (payload: any) => (dispatch: any) => {
    return new Promise(async (resolve, reject) => {
      const functions = getFunctions()
      const getVideos = httpsCallable(functions, 'getVideos')
      dispatch({
        type: Action.GET_VIDEOS_INIT,
      })
      if (payload?.length && payload?.length < 4) {
        payload = payload + '    ';
      }

      getVideos({'query': payload})
      .then((photos:any) => {
          if (photos?.data && photos?.data?.photos?.length > 0) {
              dispatch({
              type: Action.GET_VIDEOS_SUCCESS,
              payload: photos?.data?.photos,
              })
              resolve(photos?.data?.photos)
          } else {
              dispatch({
                  type: Action.GET_VIDEOS_SUCCESS,
                  payload: photos?.data?.photos,
                  })
                  resolve([])
                }
          })
          .catch((error) => {
              dispatch({
              type: Action.GET_VIDEOS_FAIL,
              payload: error,
              })
              reject(error)
          })
      })
  }

  export const getProducts: any = () => (dispatch: any) => {
    //console.log('getProducts')
    return new Promise(async (resolve, reject) => {
      const functions = getFunctions()
      const getProducts = httpsCallable(functions, 'getProducts')
      dispatch({
        type: Action.GET_PRODUCTS_INIT,
      })

      getProducts()
      .then((prod:any) => {
          //console.log('products33', prod)
          if (prod?.data) {
            console.log('products33', prod?.data)
              dispatch({
              type: Action.GET_PRODUCTS_SUCCESS,
              payload: prod?.data,
              })
              resolve(prod?.data)
          } else {
              dispatch({
                  type: Action.GET_PRODUCTS_FAIL,
                  payload: 'Bad Payload',
                  })
                  resolve({})
                }
          })
          .catch((error) => {
              dispatch({
              type: Action.GET_PRODUCTS_FAIL,
              payload: error,
              })
              reject(error)
          })
      })
  }